import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { GlobalNavigation } from 'site-modules/shared/components/global-navigation-v2/global-navigation';
import { Footer } from 'site-modules/shared/components/footer/footer';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SpaLinks } from 'site-modules/shared/components/spa-links/spa-links';
import { ProfileContextAsync } from 'site-modules/shared/components/profile/profile-context-async';
import { ExperimentsPanel } from 'site-modules/shared/components/experiment/panel/experiments-panel';
import { AdsContext } from 'site-modules/shared/components/ads-context/ads-context';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { ErrorPageMessage } from 'site-modules/shared/components/error-page-message/error-page-message';
import { PubpixelAd } from 'site-modules/shared/components/pubpixel/pubpixel-ad';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { VisitorModel } from 'client/data/models/visitor';
import { SEOHead } from 'site-modules/shared/pages/seo';
import { FloodlightAd } from 'site-modules/shared/components/floodlight/floodlight-ad';
import { SkipToMainContent } from 'site-modules/shared/components/skip-to-main-content/skip-to-main-content';

const CREATIVE_ID_PREFIX = 'edmunds-cpa-no-adhesion';

class EdmundsCpaNoAdhesionDecoratorUI extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    skipFloodlight: PropTypes.bool,
    skipPubpixel: PropTypes.bool,
    skipFooter: PropTypes.bool,
    showSearchBar: PropTypes.bool,
    isMobile: PropTypes.bool,
    renderLogo: PropTypes.func,
    searchBarComponent: PropTypes.elementType,
    withAiLink: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    skipFloodlight: false,
    skipPubpixel: false,
    skipFooter: false,
    showSearchBar: true,
    isMobile: false,
    renderLogo: undefined,
    searchBarComponent: undefined,
    withAiLink: true,
  };

  static preload(store) {
    const preloader = new ModelPreloader(store);
    preloader.resolve('rttSegment', VisitorModel);

    return preloader.load();
  }

  render() {
    const {
      children,
      isMobile,
      skipFloodlight,
      skipPubpixel,
      skipFooter,
      showSearchBar,
      className,
      renderLogo,
      searchBarComponent,
      withAiLink,
    } = this.props;

    return (
      <div className={classnames('edm-page has-global-nav', className, { desktop: !isMobile })}>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-nav`}>
          <SkipToMainContent />
          <GlobalNavigation
            showSearchBar={showSearchBar}
            renderLogo={renderLogo}
            searchBarComponent={searchBarComponent}
            withAiLink={withAiLink}
          />
        </ErrorBoundary>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-seohead`}>
          <SEOHead {...this.props} />
        </ErrorBoundary>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-spa`}>
          <FeatureFlag name="testSpa">
            <SpaLinks />
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-content`} Fallback={ErrorPageMessage}>
          {children}
        </ErrorBoundary>
        {!skipFooter && (
          <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-footer`}>
            <Footer />
          </ErrorBoundary>
        )}
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-ads`}>
          <FeatureFlag name="ads">
            {!skipFloodlight && (
              <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-floodlight`}>
                <FloodlightAd />
              </ErrorBoundary>
            )}
            {!skipPubpixel && (
              <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-pubpixel`}>
                <PubpixelAd />
              </ErrorBoundary>
            )}
            <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-ads-context`}>
              <AdsContext />
            </ErrorBoundary>
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-insider`}>
          <FeatureFlag name="insider">
            <ProfileContextAsync />
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary creativeId={`${CREATIVE_ID_PREFIX}-experiments`}>
          <ClientSideRender>
            <ExperimentsPanel />
          </ClientSideRender>
        </ErrorBoundary>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const EdmundsCpaNoAdhesionDecorator = connect(mapStateToProps)(EdmundsCpaNoAdhesionDecoratorUI);
